import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { BOOKING_GET_BOOKING_I18N } from 'Utils/request/requestDictionary';
export function fetchBookingEngineI18nQuery(appContext: AppContext) {
  return graphQLClient.runQuery('', appContext, {
    requestName: BOOKING_GET_BOOKING_I18N,
    queryId: BOOKING_GET_BOOKING_I18N,
  });
}
